import api from "api";
import { supportApiBase } from "api/constants";
import { useQuery } from "react-query";
import { queryKeys } from "utils/misc";

interface GetExercisesParams {
  locale?: string;
  search?: string;
  state?: "draft" | "in_review" | "approved" | "rejected";
  joint?: Array<string>;
  position?: Array<string>;
  movement?: Array<string>;
  equipment?: Array<string>;
  page?: number;
  limit?: number;
}

export const useGetExercises = (params: GetExercisesParams = {}) => {
  const { search, state, joint, position, movement, equipment, page = 1, limit = 10, locale = "sv-SE" } = params;

  const queryParams = new URLSearchParams();
  if (locale) {
    queryParams.set("locale", locale);
  }
  if (page !== undefined) {
    queryParams.set("page", (page + 1).toString());
  }
  if (limit !== undefined) {
    queryParams.set("limit", limit.toString());
  }
  if (locale) {
    queryParams.set("locale", locale);
  }
  if (state) {
    queryParams.set("state", state.toString());
  }
  if (joint?.length) {
    joint.forEach(j => {
      queryParams.append("joint", j.toString());
    });
  }
  if (position?.length) {
    position.forEach(p => {
      queryParams.append("position", p.toString());
    });
  }
  if (movement?.length) {
    movement.forEach(m => {
      queryParams.append("movement", m.toString());
    });
  }
  if (equipment?.length) {
    equipment.forEach(e => {
      queryParams.append("equipment", e.toString());
    });
  }

  if (search?.trim()) {
    queryParams.set("search", search.trim());
  }

  return useQuery(queryKeys.getExercises(params), () =>
    // @ts-ignore
    api.parse(`GET /exercises?${queryParams.toString()}`, {
      root: supportApiBase,
    })
  );
};
